import React from 'react';
export function Logo({
  className = '',
  variant = 'light'
}: {
  className?: string;
  variant?: 'light' | 'blue';
}) {
  const src = variant === 'light' ? 'https://cdn.magicpatterns.com/uploads/kDBcuwftx5DuxHmdn4UwmN/1.png' : 'https://cdn.magicpatterns.com/uploads/upMCHfQ1coKvYmzrDbuoiJ/2.png';
  return <div className={`flex items-center justify-center ${className}`} data-id="element-397" data-mp="3v9fu98wha4al">
      <img src={src} alt="GONE FISHING" className="w-full h-auto object-contain mix-blend-multiply" style={variant === 'blue' ? {
      mixBlendMode: 'normal'
    } : {}} data-id="element-398" data-mp="mscomud9uuz1" />
    </div>;
}